export default __webpack_public_path__ + "static/media/top-loading.475ca145.svg";